<template>
  <BaseOverlay
    class="subscription-expired-overlay"
    :close-btn="closable"
    @close="$emit('close')"
  >
    <div class="subscription-expired-modal">
      <div class="subscription-expired-modal__icon">
        <img src="/img/renova-dashboard/icons/subsription-expired.svg" alt="expired">
      </div>
      <h2 class="subscription-expired-modal__title h3">{{ title || $t('subscription.expiredTitle') }}</h2>
      <p class="subscription-expired-modal__text body-text">{{ text || $t('subscription.expiredText') }}</p>
      <BaseButton
        class="subscription-expired-modal__button"
        @click="onAction"
      >
        {{ buttonText || $t('subscription.goToPayment') }}
      </BaseButton>
    </div>
  </BaseOverlay>
</template>

<script>
import BaseOverlay from '@/views/RenovaDashboard/components/ui-kit/BaseOverlay';
import BaseButton from '@/views/RenovaDashboard/components/ui-kit/Buttons/BaseButton';
import { mapGetters } from 'vuex';

export default {
  name: 'SubscriptionExpiredModal',
  components: {
    BaseOverlay,
    BaseButton,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    buttonText: {
      type: String,
      default: '',
    },
    closable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(['selectedInsuranceProviderDetails']),
  },
  methods: {
    onAction() {
      this.$emit('action');
      this.goToPayment();
    },
    goToPayment() {
      if (this.$listeners.action) return;
      this.$emit('close');
      this.$router.push(`/admin/provider/${this.selectedInsuranceProviderDetails?.id}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.subscription-expired-overlay {
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.subscription-expired-modal {
  background: #FFFFFF;
  border-radius: 24px;
  padding: 40px;
  width: 100%;
  max-width: 441px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);

  &__icon {
    position: relative;
    margin-bottom: 24px;
    width: 77px;
    height: 77px;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 77px;
    }
  }

  &__icon-badge {
    position: absolute;
    bottom: -4px;
    right: -4px;
    width: 24px;
    height: 24px;
    background: #FFFFFF;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    img {
      width: 20px;
    }
  }

  &__title {
    color: var(--solid-black-purple);
    margin-top: 0;
    margin-bottom: 8px;
  }

  &__text {
    color: var(--solid-dark-purple);
    margin-bottom: 32px;
  }

  &__button {
    min-width: 180px;
    height: 48px;
    font-size: 16px;
  }
}
</style>
